import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1c261366")

_pushScopeId("data-v-1c261366")
const _hoisted_1 = { class: "h-100" }
const _hoisted_2 = { class: "d-flex justify-content-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h5", { class: "mb-2 me-auto" }, "Detail Pembayaran", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = { class: "table table-striped table-sm" }
const _hoisted_6 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "No"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Kelas"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Nama"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Tagihan"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Nominal"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Status"),
    /*#__PURE__*/_createVNode("th", { scope: "col" }, "Tgl Bayar")
  ])
], -1)
const _hoisted_7 = {
  key: 0,
  class: "badge bg-danger"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  style: {"background-color":"#ffbaba","color":"#d8000c","text-align":"center","padding":"5px","display":"none"},
  id: "footer-detail-payment"
}, " No more data ", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", null, [
        _createVNode("input", {
          type: "search",
          class: "form-control form-control-sm",
          placeholder: "Cari...",
          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.search && _ctx.search(...args)))
        }, null, 32)
      ])
    ]),
    _hoisted_4,
    _createVNode("table", _hoisted_5, [
      _hoisted_6,
      _createVNode("tbody", {
        onScroll: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scroll && _ctx.scroll(...args)))
      }, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.invoices, (invoice) => {
          return (_openBlock(), _createBlock("tr", {
            key: invoice.no
          }, [
            _createVNode("td", null, _toDisplayString(invoice.no), 1),
            _createVNode("td", null, _toDisplayString(invoice.kelas), 1),
            _createVNode("td", {
              class: invoice.user_status === 'Inactive' ? 'text-danger' : ''
            }, [
              _createTextVNode(_toDisplayString(invoice.nama) + " ", 1),
              (invoice.user_status === 'Inactive')
                ? (_openBlock(), _createBlock("span", _hoisted_7, "Inactive User"))
                : _createCommentVNode("", true)
            ], 2),
            _createVNode("td", null, _toDisplayString(invoice.tagihan), 1),
            _createVNode("td", null, "Rp. " + _toDisplayString(invoice.nominal.toLocaleString()), 1),
            _createVNode("td", null, [
              _createVNode("span", {
                class: invoice.status == 'Lunas' ? 'gbadgesuc' : 'gbadgeerr'
              }, _toDisplayString(invoice.status), 3)
            ]),
            _createVNode("td", null, _toDisplayString(invoice.dibayarkan), 1)
          ]))
        }), 128))
      ], 32)
    ]),
    _hoisted_8
  ]))
})